import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Ticket, SpecialTicketData } from '../shared/models/ticket';
import { WebAPIClient } from './http-services/http-service';
import { PurchaseFormService } from './purchase-form.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BackendError } from './error-service';
import { LocalizedDataUtility } from './utility/localized-data.util';

@Injectable({
    providedIn: 'root'
})
export class TicketService {
    private ticketsSubject = new BehaviorSubject<Ticket[]>([]);
    private ticketDataSubject = new BehaviorSubject<SpecialTicketData | null>(null);

    public tickets$ = this.ticketsSubject.asObservable();
    public ticketData$ = this.ticketDataSubject.asObservable();

    constructor(
        private client: WebAPIClient,
        private formService: PurchaseFormService,
        private localizedDataUtility: LocalizedDataUtility
    ) { }

    loadTicketData(id: string): Observable<SpecialTicketData> {
        return this.client.get<SpecialTicketData>(`SpecialTicketProduct/${id}`).pipe(
            map(data => this.localizedDataUtility.extractLocalizedData(
                data,
                ['name', 'description', 'validityText']
            )),
            tap(ticketData => {
                this.ticketDataSubject.next(ticketData);
                this.formService.initializeTickets(ticketData);
            }),
            catchError((err: HttpErrorResponse) => {
                const backendError: BackendError = {
                    Id: 'REJSEBILLET.WEB.PURCHASE.LOADING_FAILED',
                    operationId: err.headers.get('X-Operation-ID') ?? undefined
                };
                return throwError(() => backendError);
            })
        );
    }
}